import React, { useCallback } from 'react'
import SegmentedOptionsGroup, { SegmentedOptionsGroupOnValueChangeHandler } from 'LuxKit/SegmentedOptions/SegmentedOptionsGroup'
import SegmentedOption from 'LuxKit/SegmentedOptions/SegmentedOption'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { setTourPriceMode } from 'actions/tour/TourV2Actions'
import { getTourPriceMode } from 'selectors/TourV2/toursSelectors'

function TourPriceToggle() {
  const tourPriceMode = useAppSelector(getTourPriceMode)
  const dispatch = useAppDispatch()
  const handleChange = useCallback<SegmentedOptionsGroupOnValueChangeHandler>((newValue) => {
    dispatch(setTourPriceMode(newValue as 'total' | 'perDay'))
  }, [dispatch])

  return (<form>
    <SegmentedOptionsGroup
      inputsName="tourPriceMode"
      density="compact"
      onValueChange={handleChange}
    >
      <SegmentedOption
        checked={tourPriceMode === 'total'}
        value="total"
        title="Total price"
      />
      <SegmentedOption
        checked={tourPriceMode === 'perDay'}
        value="perDay"
        title="Price per day"
      />
    </SegmentedOptionsGroup>
  </form>)
}

export default TourPriceToggle
